export function formatMilestoneDate(isoDate: string | null): string {
  if (!isoDate) {
    return "Sem previsão nos próximos 30 anos";
  }

  const date = new Date(`${isoDate}T12:00:00`);

  if (Number.isNaN(date.getTime())) {
    return isoDate;
  }

  return new Intl.DateTimeFormat("pt-BR", {
    month: "long",
    year: "numeric",
  }).format(date);
}
